import { call,put, select } from "redux-saga/effects";
import { removeIncomingCallSaga } from "../../callSessions/removeIncomingCall/removeIncomingCall";
export function* acceptCallSaga(action) {
    const callSession = action.payload;
    
    try {
        callSession.accept();

        // Remove the call from incomingCalls
        yield call(removeIncomingCallSaga, { payload: callSession.id });

        console.log("Call accepted successfully");
    } catch (error) {
        console.error("Error accepting call:", error);
    }


}